<template>
<div @click="clickItem(item)" class="game row position-relative cursor-pointer">
	<div class="col-12 mb-3">
	    <div class="card shadow h-100 p-0 p-md-2 position-relative">
	        <div class="card-body pt-1 pt-md-0 pb-0">
	            <div class="row align-items-center h-100">
	                <div class="cover col-1 col-md-2 mr-2 h-100 d-mobile-none" :style="{ backgroundImage: 'url(\''+item.image+'\')' }"></div>
	                <div class="col pl-0 pl-md-2 ml-md-1">
	                    <div class="cover bg-md-none pl-5 pl-md-1 ml-n1 ml-md-0" :style="{ backgroundImage: 'linear-gradient(to right, transparent 0%, transparent 6%, #FFFFFF 15%, #FFFFFF 100%), url(\''+item.image+'\')' }">
	                        <div class="row no-gutters mb-1">
	                            <div class="col mr-2">
	                                <span class="h4 mb-0 font-weight-bold text-black-800 fs-mobile-5 shadow-white name">
	                                    {{ item.name }} 
	                                    <span><i class="h6 fa-solid fa-arrow-up-right-from-square d-mobile-none"></i></span>
	                                </span>
	                            </div>
	                            <div class="col-3 text-right">
	                                <h4 class="text-right fs-mobile-5 fs-md-4 text-black">
	                                    <strong class="">{{item.games_no}} <span class="fs-mobile-6 fs-md-5 fw-bold">jocuri</span></strong>
	                                </h4>
	                            </div>
	                        </div>
	                        <div class="row no-gutters mb-1">
	                            <div class="col">
	                                <div class="shadow-white stats text-xs text-md-s">
							            <span class="d-mobile-none" v-for="(game, i) in item.games">
							                <strong>{{game.name}}</strong>
							                <span v-if="game.price"> - {{game.price}} RON</span><span v-if="i < item.games.length - 1">, </span>
							            </span>
						                <span class="d-mobile-none" v-if="item.games_no > item.games.length">, [...]</span>
							            <span class="d-md-none" v-for="(game, i) in item.games.slice(0,3)">
							                <strong>{{game.name}}</strong>
							                <span v-if="game.price"> - {{game.price}} RON</span><span v-if="i < item.games.slice(0,3).length - 1">, </span>
							            </span>
						                <span class="d-md-none"v-if="item.games_no > 3">, [...]</span>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</div>
</template>
<script>
    import Vue from "vue";
    import HelperItemMixin from "../mixins/HelperItemMixin";

    export default {
        name: "ListItem",
        props: ['item', 'index'],
        data() {
            return {}
        },
        mounted() {},
        methods: {
            clickItem: function(item) { 
            	window.open('/list/'+item.id, "_blank");
            },
        }
    };
</script>